/**
 * Tive adapter stub — IOT-DEPLOY-DARK-1 Day 2.
 *
 * Tive Solo 5G is a TYPE-ONLY integration: device profiles and capability
 * matrices are declared; live API calls (telemetry, config push, health)
 * throw VendorNotIntegratedError. Full integration is scheduled post-pilot.
 *
 * Supported models: Solo5G
 * Capability surface: temperature, humidity, shock, light, tilt, GPS.
 * Config push: cloud-only (Tive cloud API, not onboard). OTA not supported.
 */

import { NotImplementedAdapter } from '../NotImplementedAdapter.js';

const TIVE_CAPABILITIES = {
  configKeys: {
    reporting_interval_sec: {
      pushable: true,
      readable: true,
      range: [30, 3600],
      requiresActivation: false,
      unit: 'seconds',
      description: 'Telemetry reporting interval',
    },
    temp_alert_max_c: {
      pushable: true,
      readable: true,
      range: [-40, 85],
      requiresActivation: false,
      unit: '°C',
      description: 'Temperature upper alert threshold',
    },
    temp_alert_min_c: {
      pushable: true,
      readable: true,
      range: [-40, 85],
      requiresActivation: false,
      unit: '°C',
      description: 'Temperature lower alert threshold',
    },
  },
  telemetryTypes: [
    'temperature_c', 'humidity_pct', 'shock_g', 'light_lux', 'tilt_deg', 'gps_position',
    'battery_soc_pct',
  ],
  alertingMode: 'cloud',
  otaSupported: false,
  attestationSupported: false,
  rollbackSupported: false,
  pushLatencyExpectedMs: 30_000,
};

export class TiveAdapter extends NotImplementedAdapter {
  constructor(device) {
    super(device, 'tive', TIVE_CAPABILITIES);
  }
}

/**
 * Factory for HalService.registerAdapter('tive', createTiveAdapterFactory()).
 */
export function createTiveAdapterFactory() {
  return (device) => new TiveAdapter(device);
}
